var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('header-band',{attrs:{"back":true,"blueCleanfox":true,"title":_vm.$t('login_email_web_header')},on:{"eventBack":_vm.eventBack}}),_c('email-redirect')],1)}
var staticRenderFns = []

export { render, staticRenderFns }